<gala-filtre (display)="showFiltre($event)" />

<div class="filtre" [hidden]="boFiltreHide">
    <ul>
        <li> {{this.translate.instant("FILTER")}} </li>
        <li>
            <select-filtre [options]="filtreStatut" (selected)="filtrer()" [placeholder]="lgTrad.DISPLAY" />
        </li>
        <li>
            <select-filtre [options]="filtreEchange" (selected)="filtrer()" [placeholder]="lgTrad.TYPEEXCH" />
        </li>
        <li>
            <div class="total">{{translate.instant("FILTERS.TOTAL")}} <span>{{getListeFiltree().length}}</span>
            </div>
        </li>
    </ul>
</div>

<div>
    <table class="table table-striped">
        <thead>
            <tr>
                @for (head of headElements; track head) {
                <th (click)="sortBy(head.tri)" [ngClass]="(head.sortable)?'cursor-hand':'cursor-arrow'">
                    {{head.libelle}}&nbsp;@if (head.sortable) {
                    <cp-icon-sort [col]="sColTri === head.tri" [boo]=booAscendant />
                    }
                </th>
                }
                <th></th>
            </tr>
        </thead>
        <tbody>
            @for (listesync of listeElementsAff; track listesync) {
            <tr>
                <td>{{ listesync.DEBSYNC | dateTimeFormat }}</td>
                <td>{{ listesync.FINSYNC | dateTimeFormat }}</td>
                <td dirAgentActivite [agent]="listesync.AGENT">{{ listesync.AGENT.NOM }} {{ listesync.AGENT.PRENOM }}
                </td>
                <td>{{ listesync.AGENT.TELA.INDICATIF + " " + listesync.AGENT.TELA.NUMERO }}</td>
                <td>{{ listesync.AGENT.LISTESIG[0].NOMSIG }}</td>
                <td>{{ listesync.VERSION }}</td>
                <td class="text-center">
                    <sync-icon-echange [synchro]="listesync" />
                </td>
                <td>
                    <cp-icon-sync [statut]="listesync.SYNCHOK" />
                </td>
                <td>
                    <gala-btn-search (click)="showListeSync(listesync)" />
                </td>
            </tr>
            }
        </tbody>
    </table>
    <paginator />
</div>